






























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {Inject} from "vue-typedi";
    import { EventBus } from '@/helpers/EventBus';
    import { Zone } from '@/model/Zone';
    import { StoreService } from '@/services/StoreService';
    import ZoneFilter from '@/components/ZoneFilter.vue';
    import authentication from '@/configuration/authentication';
    import { ZoneFilterBehaviour } from './ZoneFilter.vue';
    import SwitchToggle from './SwitchToggle.vue';
import DateRangeFilter from '@/components/calendar/DateRangeFilter.vue';
import {CalendarRange} from "@/model/calendar/CalendarRange";

    @Component({
        components: {ZoneFilter, SwitchToggle, DateRangeFilter}
    })
    export default class ItemsListDashboard extends Vue {

        @Prop({}) public displayMode: DisplayMode;
        @Prop({default: false}) public isAllUnfolded: boolean;
        @Prop({default: false}) public canFilterMissing: boolean;
        @Prop({default: false}) public canHandleSupports: boolean;
        @Prop({default: 0}) public resetMissingFilterKey: number;

        @Inject()
        storeService!: StoreService;

        // Expose enums to the vue
        protected ZoneFilterBehaviour = ZoneFilterBehaviour;

        private allZones: Zone[] = [];
        protected selectedZones: Zone[] = [];
        private areFiltersDisplayed: boolean = false;
        public withDelay: boolean = false;
        public withMissing: boolean = false;
        public withCateringService: boolean = false;
        private selectedRange: CalendarRange | null = null;

        created() {
            this.storeService.getStoreById().then(store => {
                if (!store.zones) {
                    this.allZones = [];
                    return;
                }

                this.allZones = store.zones.filter(zone => authentication.isAuthorizedZone(zone.zoneCode));
                this.loadSelectedZones(this.allZones);
            });
            this.selectedRange = this.storeService.selectedRange;
            this.withCateringService = this.storeService.isOrderWithCateringService;
            this.withDelay = this.storeService.isOrderWithDelay;
            this.withMissing = this.storeService.isOrderWithMissing;
        }

        setFilterWithDelayActivated(isActivated: boolean) {
            this.withDelay = isActivated;
            this.storeService.saveWithDelayFilter(isActivated);
        }

        setFilterWithMissingActivated(isActivated: boolean) {
            this.withMissing = isActivated;
            this.storeService.saveWithMissingFilter(isActivated);
        }

        setFilterWithCateringServiceActivated(isActivated: boolean) {
            this.withCateringService = isActivated;
            this.storeService.saveWithCateringServiceFilter(isActivated);
        }

        setFilterWithRange(selectedRange: CalendarRange | null) {
            this.selectedRange = selectedRange;
            this.storeService.saveSelectedRange(selectedRange);
        }

        private loadSelectedZones(selectableZones: Zone[]) {
            const selectedZoneCodes = this.storeService.selectedAndEnabledZones;
            const selectedZones = selectableZones.filter(zone => selectedZoneCodes.includes(zone.zoneCode));
            if (selectedZones.length !== this.allZones.length) {
                this.selectedZones = selectedZones;
                return;
            }

            this.selectedZones = [];
        }

        onZoneSelectionChanged(selectedZoneCodes: string[]) {
            this.selectedZones = this.allZones.filter(zone => selectedZoneCodes.includes(zone.zoneCode));
            this.storeService.saveSelectedZones(selectedZoneCodes);
        }

        isFiltersSelected() {
            const hasSelectedRange = this.selectedRange != null && this.selectedRange.startDate != null && this.selectedRange.endDate != null;
            if (this.selectedZones == null || this.allZones == null ) {
                return false;
            }

            return !(this.selectedZones.length === 0 || this.selectedZones.length === this.allZones.length) || this.withDelay || this.withMissing || hasSelectedRange;
        }

        public toggleDisplay() {
            EventBus.$emit(EventBus.TOGGLE_DISPLAY, this.isDisplayedByOrders ? DisplayMode.PRODUCTS : DisplayMode.ORDERS);
        }

        public toggleFolding() {
            EventBus.$emit(EventBus.TOGGLE_FOLDING, !this.isAllUnfolded);
        }

        public toggleFilters() {
            this.areFiltersDisplayed = !this.areFiltersDisplayed;
        }

        get isDisplayedByOrders() {
            return this.displayMode === DisplayMode.ORDERS;
        }

        @Watch("resetMissingFilterKey", {immediate: true})
        resetMissingFilter() {
            this.setFilterWithMissingActivated(false);
        }
    }
    
    export enum DisplayMode {
        ORDERS, PRODUCTS
    }
